import apiClient from '../api/axios';
import { API_ENDPOINTS } from '../api/endpoints';

export interface SubmitContentPayload {
  prompt: string;
}

export const submitContent = async (payload: FormData | { prompt: string }) => {
  const response = await apiClient.post(API_ENDPOINTS.AI_CONTENT, payload);

  return response.data;
};
